import React from 'react';
import WedgeIcon from "@/components/icons/WedgeIcon";

const SummaryCategoryFooter = ({icon, label='Category', played=0, collected=0, average=0, pieColor='#1D2142'}) => {
	return <div className={`text-primary grid grid-cols-5 items-center rounded-lg w-full font-gBold lg:text-md md:text-xs text-xs px-1 pt-2`}>
		<div className={'flex uppercase flex-grow w-full whitespace-nowrap lg:text-lg md:text-md sm:text-sm text-xs col-start-2 -mx-5'}>{label}</div>
		<div className={'flex items-center justify-end col-start-4'}>
			<span className={'pr-2'}>{collected} / {played}</span>
			<WedgeIcon color={pieColor} />
		</div>
		<div className={'flex justify-end lg:text-2xl md:text-lg text-sm col-start-5'}>{Math.round(average * 100)}%</div>
	</div>
}

export default SummaryCategoryFooter;
